import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      stars: '★★★★★',
      text: '«دو ساله با افراسل کار می‌کنم. سرور VPS هیچ‌وقت قطع نشده و پشتیبانی واقعاً سریع جواب می‌ده.»',
      author: 'علی محمدی — توسعه‌دهنده وب، تهران',
    },
    {
      stars: '★★★★★',
      text: '«برای تمام مشتریانم از هاست افراسل استفاده می‌کنم. قیمت عادلانه و سرویس بی‌نقص.»',
      author: 'سارا رضایی — مدیر آژانس دیجیتال',
    },
    {
      stars: '★★★★★',
      text: '«تیم افراسل سرور رو برام کانفیگ و هاردن کردن. نتیجه فوق‌العاده بود — کاملاً حرفه‌ای.»',
      author: 'رضا کریمی — مدیر فروشگاه آنلاین',
    },
  ];

  return (
    <section className="testi" id="testimonials">
      <div className="wrap">
        <div className="sec-header">
          <span className="sec-tag">نظرات مشتریان</span>
          <h2 className="sec-h">آن‌ها که به افراسل اعتماد کردند</h2>
        </div>
        <div className="testi-grid">
          {testimonials.map((t, i) => (
            <div key={i} className="tcard">
              <div className="tstars">{t.stars}</div>
              <div className="ttext">{t.text}</div>
              <div className="tauthor">{t.author}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
